import React, { Component } from 'react';
import axios from 'axios'
import { serverIp,  } from '../../../../config/constants.js'
import { Button, Icon } from 'semantic-ui-react'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'


class SetVinylHeatPress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: ''
        }
    }

    
    componentDidMount(){
        console.log("++++++++++:setVinyl_heat_press");
        console.log("this.props.order.key:" + this.props.order.key);
       // console.log("this.props.user.email:" + this.props.user.email);
    }

    setVinyl = () => {
        this.setVinyl_heat_press('vinyl');
    }

    setHeatPress = () => {
        this.setVinyl_heat_press('heatPress');
    }

    setVinyl_heat_press = (type) => {
        console.log("++++++++++:setVinyl_heat_press");
        console.log("this.props.order.key:" + this.props.order.key);
        console.log("this.props.user.email:" + this.props.user.email);

        let tempType = '';

        let orderUpdates = '';

        if (type === 'vinyl') {

            tempType = 'vinyl';

            orderUpdates = {
                vinyl: true,
                vinylBy: this.props.user.email
            }

        } else if (type === 'heatPress') {

            orderUpdates = {
                heatPress: true,
                heatPressBy: this.props.user.email
            }
        }


        //UPDATE INDY ORDER
        FbUtils.updateIndividualOrder(this.props.mainOrder.key, this.props.orderId, orderUpdates);

        //UPDATE MAIN ORDER
        FbUtils.updateOrder(this.props.mainOrder.key, orderUpdates);


        this.setState({
            type: tempType
        })

        let eventProperties = {
            heatPress_Vinyl: this.props.user.email
        }

        this.sendUpdateToApi(type);
    }

    sendUpdateToApi(sentType) {
        axios.post(serverIp + 'orders/markHeatPressOrVinyl', {
            apiKey: 'asdferererrr',
            fbOrderKey:this.props.mainOrder.key,
            indyOrderKey: this.props.orderId,
            adminEmail: this.props.user.email,
            heatPressOrVinyl: sentType
        })
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {

        const vinylButton = this.props.order.vinyl === true
            ?<h3><Icon loading name='asterisk' /> VINYL TO PRINT </h3>
            :<Button type='Button' onClick={this.setVinyl} type='button' color='purple' fluid size='large'>SET VINYL</Button>

        const heatPressButton = this.props.order.heatPress === true
            ? <h3><Icon loading color='red' name='dont' /> HEAT PRESS TO PRINT </h3>
            :<Button type='Button' onClick={this.setHeatPress} type='button' color='brown' fluid size='large'>HEAT PRESS</Button>

        return (
            <div>
                {vinylButton}
                {heatPressButton}
            </div>
        )
    }
}

export default SetVinylHeatPress;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Vinyl/SetHeatPressOrVinyl.js